import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { DashboardFeedItemCompleteProfile} from '@bluecrew/crew-member-backend-angular-client';
import { AnalyticsPlugin } from '@plugins/analytics/analytics-plugin';
import { NavigationPlugin } from '@plugins/navigation/navigation-plugin';
import { Browser } from '@capacitor/browser';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.scss'],
})
export class CompleteProfileComponent {
  topMissingField = "Complete your profile"

  @Input()
  get feedItem(): DashboardFeedItemCompleteProfile { return this._feedItem; }
  set feedItem(feedItem: DashboardFeedItemCompleteProfile) {
    const missingFields = feedItem.missingFields
    if (missingFields.includes('profilePic')) {
      this.topMissingField = "Add a profile pic"
    } else if (missingFields.includes('workHistory')) {
      this.topMissingField = "Add your work history"
    } else if (missingFields.includes('bio')) {
      this.topMissingField = "Tell workplaces about yourself"
    }
    this._feedItem = feedItem
  }
  private _feedItem: DashboardFeedItemCompleteProfile;

  constructor(private navCtrl: NavController) { }

  async onButtonClick() {
    AnalyticsPlugin.logEvent({
      name: 'dashboard_open_profile',
      params: {},
    });

    await this.navCtrl.navigateForward(AppRoutingUtil.USER_INFO_PROFILE)
  }
}
